// extracted by mini-css-extract-plugin
export var changeIcon = "_5i-4";
export var container = "_5i-0";
export var divider = "_5i-7";
export var externalLinkIcon = "_5i-1";
export var green = "_5i-5";
export var helpCircleIcon = "_5i-3";
export var iconButton = "_5i-2";
export var red = "_5i-6";